module.exports = __webpack_public_path__ + "img/antes_despues_163.6ccaeb2c.png";